import React, { Fragment, MouseEvent } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { CheckoutPortalFormattedMessage } from '../../Core/CheckoutPrtalForamattedMessage/CheckoutPortalFormattedMessage';

import EstimateActionButtons from './EstimateActionButtons';
import EstimateFooter from './EstimateFooter';
import EstimateMessage from './EstimateMessage';

import Card from 'components/Shared/Card/Card';
import Hr from 'components/Shared/Hr/Hr';
import { colors, fontSize, breakpoints } from 'styles/cp';

export interface Props {
  companyName: string;
  companyEmail: string;
  amount: number;
  depositAmount: number;
  currency: string;
  isPDFError: boolean;
  locale: string;
  pdfUrl?: string;
  acceptHandler: () => void;
  viewEstimateHandler: (event: MouseEvent) => void;
  declineHandler: () => void;
}

const EstimateDepositAccept: React.FC<Props> = ({
  companyName,
  companyEmail,
  pdfUrl,
  amount,
  depositAmount,
  currency,
  isPDFError,
  acceptHandler,
  declineHandler,
}: Props) => {
  return (
    <Fragment>
      <Card>
        <div className="main">
          <div className="estimate-deposit">
            <div className="estimate-total">
              <FormattedMessage id="ESTIMATE_TOTAL" defaultMessage="Estimate Total" />
              <span className="estimate-total--amount">
                <FormattedNumber value={amount} style="currency" currency={currency} />
              </span>
            </div>
            <div className="deposit-amount">
              <div className="deposit-amount--text">
                <FormattedMessage id="DEPOSIT_MESSAGE" defaultMessage="DEPOSIT AMOUNT" />
              </div>
              <div className="deposit-amount--value">
                <FormattedNumber value={depositAmount} style="currency" currency={currency} />
              </div>
            </div>
            <div className="view-estimate-action">
              <EstimateMessage pdfUrl={pdfUrl} isPDFError={isPDFError} />
            </div>
            <div className="deposit-how-to-pay">
              <CheckoutPortalFormattedMessage
                id="DEPOSIT_HOW_TO_PAY"
                defaultMessage="Not sure how to pay this deposit? Contact {companyName} at <a>{companyEmail}</a>"
                values={{
                  companyName,
                  companyEmail,
                  a: (chunks: string) => <a href={`mailto:${chunks}`}>{chunks}</a>,
                }}
              />
            </div>
            <Hr marginBottom={25} />
          </div>
          <EstimateActionButtons acceptHandler={acceptHandler} declineHandler={declineHandler} />
        </div>
        <EstimateFooter />
      </Card>

      <style jsx>{`
        .main {
          padding: 40px 98px 0;
          @media screen and (max-width: ${breakpoints.md}) {
            padding: 32px 16px 20px;
          }

          .view-estimate-action {
            display: none;
            @media screen and (max-width: ${breakpoints.md}) {
              display: block;
            }
          }
        }

        .decline-container,
        .change-container {
          margin: 8px 0;
        }

        .estimate-deposit {
          .estimate-total {
            font-size: ${fontSize.xs};
            color: ${colors.gray};

            &--amount {
              margin: 0 5px;
            }
          }
          .deposit-amount {
            margin-top: 30px;
            &--text {
              font-size: ${fontSize.xs};
              color: ${colors.gray02};
              text-transform: uppercase;
            }
            &--value {
              font-size: ${fontSize.lg};
              font-weight: 600;
              color: ${colors.gray};
            }
          }
          .deposit-how-to-pay {
            margin-top: 25px;
            color: ${colors.gray};

            a {
              color: ${colors.intuit_blue};
              text-decoration: none;
            }
          }
        }
      `}</style>
    </Fragment>
  );
};

export { EstimateDepositAccept };

// @ts-ignore
export default EstimateDepositAccept;
